<template>
  <div class="file-managed-simple-attachements-table">
    <div class="images-gallery" v-if="showImages" v-viewer="{movable: false}" style="display:none;">
      <img v-for="image in images" :src="image.url" :key="image.id" style="background:#fff;">
    </div>

    <Card v-for="(rows, collection_name) in data" :key="collection_name" :name="collection_name">
      <div slot="title"> {{ getCollectionValue(collection_name) }} </div>
      <Table row-key="id" :columns="columns" :data="rows">
        <template slot-scope="{ row, column, index }" slot="propsCell">
          {{_.get(row, column.key)}}
        </template>
        <template slot-scope="{ row, column, index }" slot="fileViewCell">
          <div @click="showImage(row)"><Icon v-show="row.is_image" type="ios-image" ></Icon> {{row.name}}</div>
        </template>
        <template slot-scope="{ row, column, index }" slot="actionCell">
          <div class="actions">
            <Button size="small" type="text" @click="handleDownload(row)">Download</Button>
            <Poptip
              v-if="row.is_root"
              confirm
              transfer
              title="Delete this file ?"
              @on-ok="handleDelete(row)">
               <Button size="small" type="text">Delete</Button>
            </Poptip>
            <Button v-if="row.is_root" size="small" type="text" @click="handleReplace(row)">Replace</Button>
          </div>
        </template>
      </Table>
    </Card>
  </div>
</template>

<script>
import tableFieldsDef from './data/table-list-fields'
import { getAttachments, dropFile } from '@/api/file'
import { readableBytes } from '@/libs/util'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import { saveAs } from 'file-saver'

import Vue from 'vue'
Vue.use(Viewer)

export default {
  name: 'FileManagedSimpleAttachmentsTable',
  props: {
    attachable: {
      type: Object,
      required: true
    },
    collectionMap: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      columns: tableFieldsDef.columns,
      data: [],
      images: [],
      showImages: false
    }
  },
  mounted () {
    this.loadAttachments(this.attachable.type, this.attachable.id)
  },
  methods: {
    readableBytes,
    loadAttachments (type, id) {
      getAttachments(type, id).then(resp => {
        let medias = _.map(resp.data, (item) => {
          let childMedias = []
          let props = this.getMediaResource(item.currentMedia, item)
          if (item.media && item.media.length > 0) {
            childMedias = _.map(item.media, (media) => {
              let childMedia = this.getMediaResource(media, item)
              childMedia.file_managed_id = id
              childMedia.file_managed_type = type
              return childMedia
            })
            _.remove(childMedias, (child) => {
              return child.id === item.currentMedia.id
            })
          }
          props.children = childMedias
          props.file_managed_id = id
          props.file_managed_type = type
          return props
        })
        this.data = _.groupBy(medias, (media) => {
          return media.collection_name
        })
      })
    },
    getMediaResource(media, fileManaged) {
      let imageIndex = this.findImageIndex(media)
      if (this.isImage(media) && imageIndex === -1 && media.url) {
        this.images.push(media)
      }
      return {
        file_id: fileManaged.id,
        id: media.id,
        collection_name: media.collection_name,
        url: media.url,
        name: media.name,
        description: media.custom_properties.description,
        size: readableBytes(media.size),
        created_at: media.created_at,
        is_image: this.isImage(media),
        is_root: fileManaged.currentMedia.id === media.id
      }
    },
    findImageIndex(media) {
      return _.findIndex(this.images, (image) => {
        return image.id === media.id
      })
    },
    showImage (media) {
      let imageIndex = this.findImageIndex(media)
      if (imageIndex !== -1) {
        this.showImages = true
        setTimeout(() => {
          const viewer = this.$el.querySelector('.images-gallery').$viewer
          viewer.index = imageIndex
          viewer.show()
        }, 100)
      }
    },
    isImage(media) {
      return _.startsWith(media.mime_type, 'image')
    },
    update () {
      this.loadAttachments(this.attachable.type, this.attachable.id)
    },
    handleDownload(media) {
      saveAs(media.url, media.name)
      // let link = document.createElement('a')
      //   link.style.display = 'none'
      //   link.href = media.url
      //   link.target = '_blank'
      //   link.setAttribute('download', media.name)
      //   document.body.appendChild(link)
      //   link.click()
    },
    handleDelete (media) {
      dropFile(media.file_id).then((res) => {
        this.loadAttachments(this.attachable.type, this.attachable.id)
      })
    },
    handleReplace (media) {
      this.$emit('replaceFile', media.file_id)
    },
    getCollectionValue (collectName) {
      if (this.collectionMap && this.collectionMap.length > 0) {
        let collectObj = _.find(this.collectionMap, { key: collectName })
        if (collectObj) {
          return collectObj.value
        }
      }
      return collectName
    }
  }
  // watch: {
  //   attachable: {
  //     immediate: true,
  //     deep: true,
  //     handler (value) {
  //       this.loadAttachments(value.type, value.id)
  //     }
  //   }
  // }
}
</script>
<style lang="less">
.file-managed-simple-attachements-table {
  .ivu-table-cell .actions {
    margin: 0;
    font-size: 14px;
    button {
      margin: 0;
      font-size: 12px;
      display: inline;
      padding: 0 1px;
    }
  }
}
</style>
